import { useState } from "react";
import { mapTilerKey } from "./Constants";
import styles from './StyleChanger.module.css';


const StyleChanger = (props) => {

    const [selectedStyle, setSelectedStyle] = useState(1);

    const getStyleColor = (styleName) => {
        const colors = {
            "Basic": "#2980b9",
            "Bright": "#d35400", 
            "Satellite": "#34495e",
            "Topo": "#16a085",
            "Streets": "#c0392b",
            "Outdoor": "#6a478f",
            "PronuVE": "#34495e"
        };
        return colors[styleName] || "#7f8c8d";
    }; 
    
    const styleList = [
        {
            id : 1,
            name : "Basic",
            address : "https://api.maptiler.com/maps/basic-v2/style.json?key=" + mapTilerKey,
            icon : "/styleChanger/basic.png",
        },
        {
            id : 2,
            name : "Bright",
            address : "https://api.maptiler.com/maps/bright-v2/style.json?key=" + mapTilerKey,
            icon : "/styleChanger/bright.png",
        },
        {
            id : 3,
            name : "Satellite",
            address : "https://api.maptiler.com/maps/hybrid/style.json?key=" + mapTilerKey,
            icon : "/styleChanger/satellite.png",
        },
        {
            id : 4,
            name : "Topo",
            address : "https://api.maptiler.com/maps/topo-v2/style.json?key=" + mapTilerKey,
            icon : "/styleChanger/topo.png",
        },
        {
            id : 5,
            name : "Streets",
            address : "https://api.maptiler.com/maps/streets-v2/style.json?key=" + mapTilerKey,
            icon : "/styleChanger/basic.png",
        },
        {
            id : 6,
            name : "Outdoor",
            address : "https://api.maptiler.com/maps/outdoor-v2/style.json?key=" + mapTilerKey,
            icon : "/styleChanger/topo.png",
        }
    ];

    const radioButtonHandler = (event) => {
        setSelectedStyle(event.target.id);
        props.changeStyle(event.target.value);
    }

    return (
        <ul onChange={radioButtonHandler} className={styles.radioUl}>
            {styleList.map(style => {
                return (
                        <div key={style.id} className={styles.radioinputdiv}>
                        <input
                        type="radio"
                        name="styele-changer-radio-image"
                        id={style.id}
                        value={style.address}
                        className={styles.radioinput}
                        defaultChecked = {selectedStyle === style.id}
                        />
                        <div 
                            style={{
                                width: "66px",
                                height: "40px",
                                background: getStyleColor(style.name),
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "white",
                                fontSize: "10px",
                                fontWeight: "bold",
                                textAlign: "center",
                                borderRadius: "4px"
                            }}
                        >
                            {style.name}
                        </div>
                    </div>
                )
            }) }
        </ul>
    )

}
export default StyleChanger;